import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MonacoEditorModule} from '../../../../monaco-editor-wrapper/src/monaco-editor-wrapper.module';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {MonacoDocumentEditorComponent} from './monaco-document-editor.component';
import {CustomElementService} from '../../../../formbird-sc-shared/src/lib/services/custom-element.service';

import { MatAutocompleteModule} from '@angular/material/autocomplete';
import { default as pjson } from '../../../../../package.json';
import {FormbirdServicesModule} from "@formbird/services";


@NgModule({
  imports: [
    CommonModule,
    FormbirdServicesModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatTooltipModule,
    // LabelModule,
    MonacoEditorModule
  ],
  exports: [
    MonacoDocumentEditorComponent
  ],
  declarations: [
    MonacoDocumentEditorComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  providers: [

  ]
})

export class MonacoDocumentEditorModule {
  constructor(private injector: Injector, private customElementService: CustomElementService ) {
    customElementService.convertToCustomElement(MonacoDocumentEditorComponent, 'sc-monaco-document-editor', this.injector,
      pjson.version);
    customElementService.convertToCustomElement(MonacoDocumentEditorComponent, 'sc-monaco-template-editor', this.injector,
      pjson.version);
  }
}
